import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { BlockTurnsComponent } from '../block-turns/block-turns.component';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-meeting-list',
  templateUrl: './meeting-list.component.html',
  styleUrls: ['./meeting-list.component.scss'],
})
export class MeetingListComponent implements OnInit {
  @Input() normalizedDate: Date = undefined;
  @Input() filteredPerDate: any[] = [];

  constructor(
    private modalController: ModalController,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private navCtrl: NavController,
    public authSv: LoginService
  ) {}

  ngOnInit() {}

  async close() {
    await this.modalController.dismiss();
  }

  blockHour() {
    this.uiSv.showModal(
      BlockTurnsComponent,
      {
        currentDate: this.normalizedDate,
      },
      'block-turns'
    );
  }

  async editMeeting(meeting) {
    await this.close();
    this.navCtrl.navigateForward(`/meeting/${meeting.serviceId}`, {
      queryParams: {
        operatorId: meeting.operatorId,
        meetingId: meeting.id,
      },
    });
  }

  async deleteMeeting(meeting) {
    const { role } = await this.uiSv.presentAlert(
      '¿Estás seguro de eliminar la cita?',
      true
    );

    if (role === 'accept') {
      const response = await this.httpSv.itemAction(
        { meetingId: meeting.id },
        'meeting',
        'declined'
      );

      if (response.status) {
        this.modalController.dismiss('deleted');
      }
    }
  }
}
